<script setup>
/* eslint-disable */
import { ref, computed, onMounted, onUnmounted } from 'vue';

const props = defineProps(['projectImages']);

const index = ref(0);
const total = computed(() => props.projectImages.length);

const current = computed(() => props.projectImages[index.value]);

const isVideo = (src) => /\.(mp4|webm|ogg)$/i.test(src);

function prev() { index.value = (index.value - 1 + total.value) % total.value; }
function next() { index.value = (index.value + 1) % total.value; }

function onKey(e) {
  if (e.key === 'ArrowLeft')  prev();
  if (e.key === 'ArrowRight') next();
}

let _tx = null;
function onTouchStart(e) { _tx = e.touches[0].clientX; }
function onTouchEnd(e) {
  if (_tx === null) return;
  const dx = e.changedTouches[0].clientX - _tx;
  if (Math.abs(dx) > 30) dx < 0 ? next() : prev();
  _tx = null;
}

onMounted(()  => window.addEventListener('keydown', onKey));
onUnmounted(() => window.removeEventListener('keydown', onKey));
</script>

<template>
  <div class="carousel">
    <div class="carousel-media" @touchstart.passive="onTouchStart" @touchend.passive="onTouchEnd">
      <Transition name="cmedia" mode="out-in">
        <video
          v-if="isVideo(current.img)"
          :key="index"
          :src="current.img"
          class="media-el"
          controls
          playsinline
          muted
        />
        <img
          v-else
          :key="index"
          :src="current.img"
          :alt="current.title"
          class="media-el"
        />
      </Transition>
    </div>

    <div class="carousel-bar">
      <button class="carousel-btn" @click="prev" :disabled="total <= 1">&#8592;</button>
      <span class="carousel-count">{{ index + 1 }} / {{ total }}</span>
      <button class="carousel-btn" @click="next" :disabled="total <= 1">&#8594;</button>
    </div>
  </div>
</template>

<style scoped>
.carousel {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 0;
}
.carousel-media {
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 6px;
  overflow: hidden;
}
.media-el {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
.carousel-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 4px 0;
  flex: 0 0 auto;
}
.carousel-btn {
  background: none;
  border: 1px solid rgba(255,255,255,0.12);
  color: rgba(255,255,255,0.45);
  width: 44px;
  height: 44px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.15s, color 0.15s, background 0.15s;
  line-height: 1;
  -webkit-tap-highlight-color: transparent;
}
.carousel-btn:hover:not(:disabled) {
  border-color: rgba(255,255,255,0.4);
  color: #fff;
}
.carousel-btn:active:not(:disabled) {
  background: rgba(255,255,255,0.08);
}
.carousel-btn:disabled { opacity: 0.2; cursor: default; }
.carousel-count {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  font-size: 0.68rem;
  letter-spacing: 0.16em;
  color: rgba(255,255,255,0.25);
}
.cmedia-enter-active { transition: opacity 0.18s ease; }
.cmedia-leave-active { transition: opacity 0.12s ease; }
.cmedia-enter-from, .cmedia-leave-to { opacity: 0; }
</style>
